<template>
    <div v-if="!loading">
        <div class="align-right mb-3 pr-3 pr-0-md pt-3 pt-0-md">
            <a class="btn-primary" href="/commercial/installation-of-the-month">
                Submit Entry
            </a>
            <a class="btn-primary" href="/commercial/installation-of-the-month/past-entries">
                View Past Entries
            </a>
        </div>
        <div v-if="this_months_submissions.length > 0" class="mb-10">
            <div class="installation-of-the-month-submissions">
                <div v-for="submission in this_months_submissions" class="installation-of-the-month-submission" :class="{ '_winner' : submission.winner }">
                    <div class="winner-bar" v-if="submission.winner">
                        <div><i class="fal fa-medal"></i></div>
                        <div>Winning Entry</div>
                    </div>
                    <div class="details">
                        <h1 class="title">{{ submission.title }}</h1>
                        <strong class="submitted-by">Submitted by: {{ submission.user.company.name }} - {{ submission.user.name }} - {{ submission.user.email }} </strong>
                        <template v-if="submission.user.company.name !== submission.company_name || submission.user.name !== submission.contact_name || submission.user.email !== submission.email">
                            <strong class="submitted-by">Contact Details: {{ submission.company_name }} - {{ submission.contact_name }} - {{ submission.email }} </strong>
                        </template>
                        <p class="description" v-html="submission.description">
                        </p>
                        <div class="flex mt-3">
                            <a :href="'/commercial/installation-of-the-month/edit/' + submission.id" class="btn-primary">
                                View Details
                            </a>
                            <div class="btn-primary" @click.stop="pickWinner(submission.id)" v-if="!submission.winner">
                                Choose Winner
                            </div>
                        </div>
                    </div>
                    <div class="installation-of-the-month-attachments">
                        <div v-for="(attachment, index) in submission.attachments" class="attachment">
                            <div @click="selected_submission = submission, selected_image_index = index" :style="attachmentThumbUrl(attachment)" class="image">
                                <span class="view-btn"><i class="fal fa-search"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="total_count > 5">
                <div class="pagination-bar wrapper mb-3 mt-3">
                    <div class="row">
                        <div class="col">
                            <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                                class="fa fa-caret-left"></i></a>
                            <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                            <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                               class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                        </div>
                        <div class="col align-right">
                            <div class="mt-1 mb-1">
                                {{ total_count }} entries
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div v-else class="p-3">
          <strong>No entries have been submitted this month.</strong>
        </div>
        <div class="installation-of-the-month-attachments-modal-window" :class="{'open': selected_submission !== null}" @click="selected_submission = null, selected_image_index = 0" v-if="selected_submission !== null">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="selected_submission = null, selected_image_index = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-content">
                    <div class="selected-image">
                        <img :src="`${$aws_bucket_url}${selected_submission.attachments[selected_image_index].file_url}`">
                        <a class="download-button" @click.prevent="downloadAttachment(selected_submission.attachments[selected_image_index].id)">
                            <i class="fal fa-download"></i>
                        </a>
                    </div>
                    <div class="installation-of-the-month-attachments">
                        <div v-for="(attachment,  index) in selected_submission.attachments" class="attachment">
                            <a @click.prevent="selected_image_index = index" :style="attachmentThumbUrl(attachment)" class="image">
                                <span class="view-btn"><i class="fal fa-search"></i></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            this_months_submissions: [],
            current_page: 1,
            total_count: 0,
            total_pages: 0,
            loading: true,
          selected_submission: null,
          selected_image_index: 0,
        };
    },
    mounted() {
        this.loadThisMonthsSubmissions();
    },
    methods: {
        async loadThisMonthsSubmissions() {
            this.loading = true;
            axios.post( '/commercial/installation-of-the-month/loadThisMonthsSubmissions', {
                page_number: this.current_page,
            }).then((response) => {
                this.this_months_submissions = response.data.data;
                this.total_count = response.data.total;
                this.total_pages = response.data.last_page;
                this.loading = false;
            });
        },
        prevPage() {
            this.current_page = this.current_page - 1;
            this.loadThisMonthsSubmissions();
        },
        nextPage() {
            this.current_page = this.current_page + 1;
            this.loadThisMonthsSubmissions();
        },
        attachmentUrl(attachment) {
          return {'backgroundImage' : `url('${this.$aws_bucket_url}${attachment.file_url}')`};
        },
        attachmentThumbUrl(attachment) {
          return {'backgroundImage' : `url('${this.$aws_bucket_url}${attachment.thumbnail_url}')`};
        },
        downloadAttachment(attachment_id) {
          axios.post( '/commercial/installation-of-the-month/download-attachment', {
            attachment_id: attachment_id,
          }).then((response) => {
            window.location.href = response.data;
          });
        },
        pickWinner(submission_id) {

          Swal.fire({
            title: 'Are you sure?',
            text: "This entry will be marked as this month winner, they will be notified and their entry will be displayed on the dashboard.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, pick this entry'
          }).then((result) => {
            if (result.isConfirmed) {
              axios.post( '/commercial/installation-of-the-month/pickWinner', {
                submission_id: submission_id,
              }).then((response) => {
                this.loadThisMonthsSubmissions();

                Swal.fire(
                  'Winner Picked',
                  'This entry has been picked as the winner',
                  'success'
                )

              });

            }
          });
        },
    },
}
</script>
